import Footer from "./templates/Footer";
import Header from "./templates/Header";

import success from "../assets/images/success.gif"

function Success() {

    return(
        <>
        <Header />
        <div class="aboutarea__5 sp_bottom_100 sp_top_50">
            <div class="container">
                <div class="row">
                    <div className="col-xl-12 col-lg-12 text-center">
                        <img src={success} alt="" />
                                <h1>Payment Successfull!!</h1>
                                <p>Your payment is been received successfully, our team will get back to you shortly</p>
                                <p>For any queries: Call us at <a href="tel:+91 9491065567">9491065567</a> or Email us <a href="mailto:info@tradingwhales.in">info@tradingwhales.in</a></p>

                    </div>
                    </div>
            </div>
        </div>
        <Footer />
        
        </>
    )

}
export default Success;